import { MouseEventHandler } from "react";

type ImageGalleryNavComponentProps = {
    onClick: MouseEventHandler<HTMLButtonElement>;
    disabled: boolean;
    className: string;
    ariaLabel: string;
    points: string;
}

export const ImageGalleryNavComponent = (props: ImageGalleryNavComponentProps) => {
    const {
        onClick,
        disabled,
        className,
        ariaLabel,
        points
    } = props;

    return (
        <button
            type="button"
            className={`image-gallery-icon ${className}`}
            disabled={disabled}
            onClick={onClick}
            aria-label={ariaLabel}
        >
            <svg
                className="image-gallery-svg"
                xmlns="http://www.w3.org/2000/svg"
                viewBox={"6 0 12 24"}
                fill="none"
                stroke="currentColor"
                strokeWidth={undefined}
                strokeLinecap="round"
                strokeLinejoin="round"
            >
                <polyline points={points} />
            </svg>
        </button>
    );
};